import { jsx as _jsx } from "react/jsx-runtime";
import { environment } from './environments/environment';
import { EnvironmentProvider } from '@auth-app/shared-ui';
import './styles.css';
export var App = function App(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx(EnvironmentProvider, {
        environment: environment,
        children: children
    });
};
